<template>
  <label v-for="(template, i) in templates" :key="i" class="d-block" :value="i">
    <input
      type="checkbox"
      :checked="enabledTemplatesIds.has(template.id) && fullySelectedTemplates.has(template.id)"
      class="d-none"
      :class="{
        'selected-parent': enabledTemplatesIds.has(template.id),
      }"
      @input="emit('toggle', template)"
    />
    <span
      class="checkbox align-top"
      :class="{
        checked: enabledTemplatesIds.has(template.id) && fullySelectedTemplates.has(template.id),
        'selected-parent': enabledTemplatesIds.has(template.id),
      }"
    />
    <span class="d-inline-block">
      {{ template.name }}
      <div class="d-flex align-items-center">
        <small class="template-info">{{ appTranslate('%s field(s)', [template.mappings.length], 'lowercase') }}</small>
        <i v-if="deletable" class="fa fa-trash link ml-2" @click.prevent="emit('delete', template)" />
      </div>
    </span>
  </label>
</template>

<script setup lang="ts">
import { useTranslation } from '@/composables/useTranslation'
import { PropertyTemplate } from '@/models/Property'

defineProps<{
  templates: PropertyTemplate[]
  enabledTemplatesIds: Set<string>
  fullySelectedTemplates: Set<string>
  deletable?: boolean
}>()
const emit = defineEmits<{ toggle: [value: PropertyTemplate]; edit: [value: PropertyTemplate]; delete: [value: PropertyTemplate] }>()
const { appTranslate } = useTranslation()
</script>

<style lang="scss" scoped>
.template-info {
  display: block;
  font-size: 11px;
}
</style>
